export const PAGES = {
  welcome: 'Welcome',
  discover: 'Discover',
  organizations: 'Organizations',
  assessments: 'Assessments',
  agree: 'Agree',
  report: 'Report',
};

export const ITEMS_PER_PAGE_OPTIONS = [10, 25, 50];